module.exports = __webpack_public_path__ + "static/img/Padlan Alqinsi-close.38ba244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Padlan Alqinsi-close.jpg
// module id = nJGK
// module chunks = 1